package com.hyperether.goodjob.repository.remote.auth

import kotlinx.serialization.Serializable

@Serializable
data class AppleLoginRequest(
    val code: String?,
    val source:String,
)